import React from 'react';
import { intlShape, injectIntl } from 'react-intl';
import randomstring from 'uuid/v4';
import { FormattedMessage } from 'react-intl';

import NavigateAfter from '@material-ui/icons/NavigateNext';

class ListValues extends React.Component {

    state = {
        error: undefined,
        data: [],
        report_employee: undefined
    }


    static getDerivedStateFromProps(props, state) {
        const { report_employee } = props;
        if (report_employee !== state.report_employee) {
            state.report_employee = report_employee;
            const temp = report_employee 
                            && report_employee.familias 
                            && report_employee.familias.reduce((familias, f) => {
                                familias = familias.concat(
                                    f.procesos.reduce((procesos, p) => {
                                        procesos = procesos.concat(
                                            p.instancias && p.instancias.length > 0
                                            ? p.instancias.reduce((instancias, i) => {
                                                        instancias.push(
                                                            {
                                                                nlocal: i.nlocal,
                                                                fecha: i.fecha ? i.fecha.split(' ')[0] : '',
                                                                fuerarango: i.campos.reduce((fuerarango, c1) => {
                                                                                        if(c1.campos) {
                                                                                            return fuerarango || c1.campos.reduce((fuerarango, c2) => {
                                                                                                if(c2.campos) {
                                                                                                    return fuerarango || c2.campos.reduce((fuerarango, c) => {
                                                                                                        return fuerarango || c.alerta;
                                                                                                    }, false)
                                                                                                }
                                                                                                return fuerarango || c2.alerta;
                                                                                            }, false)
                                                                                        }
                                                                                        return fuerarango || c1.alerta;
                                                                                    }, false)
                                                            }
                                                        );
                                                        return instancias;
                                                    }, [])
                                                : []
                                            );
                                        return procesos;
                                    }, []));
                                return familias;
                            }, []);
            state.data = temp.reduce((result, localday) => {
                                        const key = localday.fecha+localday.nlocal;
                                        if(result[key]) {
                                            result[key].fuerarango = result[key].fuerarango || localday.fuerarango;
                                        } else  {
                                            result[key]= {
                                                nlocal: localday.nlocal,
                                                fecha: localday.fecha,
                                                fuerarango: localday.fuerarango
                                            }
                                        }
                                        return result;
                                     }, {});
            return state;
        }
        return null;
    }

    handleScroll = (e) => {
        this.props.setProminentToolBar(e.currentTarget.scrollTop === 0);
    }

    handleDetail = (e) => {
        this.props.history.push('/reports/employee/expand')
    }

    render() {
        const { intl, report_employee } = this.props;
        const { data } = this.state;

        console.log(data);

        if(data && Object.keys(data).length > 0) {

            return(
                <div className="flex_full_column">
                    <div 
                        onScroll={this.handleScroll}
                        className="flex_full_column overflow_y_scroll showbar_resumen padding_borders">
                        <div className="flex_auto_row padding_borders_flat bg_grey_blue c_white uppercase center margin_bottom_12">
                            <span className="">{report_employee.nombreTrabajador}</span>
                        </div>
                        <div className="flex_auto_row padding_borders_flat bg_cloudy_blue c_slate uppercase center margin_bottom_12">
                            <span className="">{report_employee.desde.split(" ")[0]}</span>
                            <span className="margin_left_12 margin_right_12">{"-"}</span>
                            <span className="">{report_employee.hasta.split(" ")[0]}</span>
                        </div>
                        <div className="flex_auto_row wrap margin_bottom_48">
                            {
                                Object.keys(data)
                                .sort()
                                .map((key) => 
                                    {
                                        const info = data[key];
                                        return  <div 
                                                    key={randomstring()} 
                                                    className={"boxBorder flex_auto_column center padding_borders resumen_height_100 margin_right_12 margin_bottom_12  " + ( info.fuerarango ? 'bg_lipstickligth' : 'bg_pealigth' )  }
                                                > 
                                                    <span className="flex_auto_row c_slate margin_bottom_5">{info.nlocal}</span>
                                                    <span className="flex_auto_row c_cool_grey_two">{info.fecha}</span>
                                                </div>
                                    }
                                )
                            }
                        </div>
                    </div>
                    <div className="flex_auto_row padding_borders_flat bg_bluish c_white uppercase elements_from_right fixed_resumen_bar">
                        <div className="flex_auto_row align_center hand" onClick={this.handleDetail}>
                            <div className="barlow_regular_small c_white">
                                {intl.formatMessage({ id: 'report_employee_details_button' })}
                            </div>
                            <NavigateAfter className="c_white hand" />
                        </div>
                    </div>
                </div>
            )
        } else {
            return  <div className="flex_full_column heigth100 center barlowsemicondensed_bold_small c_slate">
                        <FormattedMessage id={"no_data"} />
                    </div>;
        }
    }
}

ListValues.propTypes = {
    intl: intlShape.isRequired,
};

export default injectIntl(ListValues);



// WEBPACK FOOTER //
// ./src/components/complex/reports/employee/Resumen.js